import { wencesApi } from "@/api/wencesApi";
import {
  MONGODB_OBJECT_ID_RE,
  parseDynamicItemPrettySlug,
} from "@/utils/dynamicModelPaths";

let cachedModelNames = null;
let cacheFetchedAt = 0;
const CACHE_TTL_MS = 60_000;

async function getCachedModelNames() {
  if (cachedModelNames && Date.now() - cacheFetchedAt < CACHE_TTL_MS) {
    return cachedModelNames;
  }
  const { data } = await wencesApi.get("/api/gotrading/model-definitions");
  cachedModelNames = Array.isArray(data)
    ? data.map((m) => m && m.modelName).filter(Boolean)
    : [];
  cacheFetchedAt = Date.now();
  return cachedModelNames;
}

/**
 * Resuelve /i/:itemSlug → params modelName + itemId para DynamicModelDetail.
 */
export async function dynamicModelPrettyUrlGuard(to, from, next) {
  const slug = to.params && to.params.itemSlug;
  if (!slug) {
    return next({ name: "NotFound" });
  }

  const quick = parseDynamicItemPrettySlug(slug, []);
  if (!quick || !MONGODB_OBJECT_ID_RE.test(quick.itemId)) {
    return next({ name: "NotFound" });
  }

  try {
    const modelNames = await getCachedModelNames();
    const parsed = parseDynamicItemPrettySlug(slug, modelNames);
    if (!parsed) {
      return next({ name: "NotFound" });
    }

    const canonical = modelNames.find(
      (m) => m.toLowerCase() === parsed.modelName.toLowerCase()
    );
    if (!canonical) {
      return next({ name: "NotFound" });
    }

    to.params.modelName = canonical;
    to.params.itemId = parsed.itemId;
    next();
  } catch (error) {
    console.error("[dynamicModelPrettyUrlGuard]", error);
    next("/dashboard");
  }
}

export default dynamicModelPrettyUrlGuard;
